export const VISCOSITY_UNIT_OPTIONS = ["cP", "cSt", "mPa·s", "Pa·s"] as const;

export type ViscosityDisplayUnit = typeof VISCOSITY_UNIT_OPTIONS[number];

export const VISCOSITY_DEFAULTS = {
  value: 1,
  unit: "cP" as ViscosityDisplayUnit,
};

export const VISCOSITY_UNIT_LABELS: Record<ViscosityDisplayUnit, string> = {
  cP: "cP",
  cSt: "cSt",
  "mPa·s": "mPa·s",
  "Pa·s": "Pa·s",
};

export const VISCOSITY_QUERY_KEYS = {
  value: "viscosity",
  unit: "viscosityUnit",
  sg: "sg",
} as const;
